<template>
  <div class="home">
    <section class="home-hero">
      <div class="hero-overlay"></div>
      <div class="hero-decoration">
        <span class="hero-dot hero-dot-1"></span>
        <span class="hero-dot hero-dot-2"></span>
        <span class="hero-dot hero-dot-3"></span>
        <div class="hero-ring hero-ring-1"></div>
        <div class="hero-ring hero-ring-2"></div>
      </div>
      <div class="hero-content">
        <p class="hero-badge">TIMELY ELECTRIC</p>
        <h1 class="hero-title animate-fade-up">{{ title[0] }}</h1>
        <p class="hero-text animate-fade-up">{{ title[1] }}</p>
        <div class="hero-actions animate-fade-up">
          <el-button type="primary" size="large" class="hero-btn" @click="handleQuote">{{ title[2] }}</el-button>
          <el-button plain size="large" class="hero-btn hero-btn-outline" @click="handleProduct">{{ title[3] }}</el-button>
        </div>
      </div>
    </section>

    <section class="home-mission">
      <div class="mission-decoration">
        <div class="mission-shape"></div>
      </div>
      <div class="mission-content">
        <span class="section-accent"></span>
        <h2>{{ title1[0] }}</h2>
        <p class="mission-text">{{ title1[1] }}</p>
        <p class="mission-text">{{ title1[2] }}</p>
        <el-button round type="primary" size="large" class="mission-btn" @click="handleAbout">{{ title1[3] }}</el-button>
      </div>
    </section>

    <section class="home-service">
      <div class="service-inner">
        <div class="service-header">
          <span class="section-accent"></span>
          <h2>{{ title2[0] }}</h2>
        </div>
        <div class="service-cards">
          <div class="service-card" v-for="(card, idx) in serviceCards" :key="idx" :style="{ '--delay': idx * 0.15 + 's' }">
            <div class="service-card-icon">
              <el-icon :size="28"><component :is="card.icon" /></el-icon>
            </div>
            <h3 class="service-card-title">{{ card.label }}</h3>
          </div>
        </div>
        <!-- <div class="service-image-wrapper">
          <el-image fit="scale-down" :src="serviceUrl" alt="service" class="service-image" />
        </div> -->
      </div>
    </section>

    <section class="home-partner">
      <div class="partner-inner">
        <div class="partner-header">
          <span class="section-accent"></span>
          <h2>{{ title3 }}</h2>
        </div>
        <div class="partner-grid">
          <el-link href="https://ameleco.com" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner1Url" alt="Ameleco" class="partner-logo" />
          </el-link>
          <el-link href="https://ebhorsman.com" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner2Url" alt="E.B. Horsman" class="partner-logo" />
          </el-link>
          <el-link href="https://sselectrician.ca" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner3Url" alt="SS Electrical" class="partner-logo" />
          </el-link>
          <el-link href="https://vancouver.homapp.com" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner4Url" alt="HomApp" class="partner-logo" />
          </el-link>
        </div>
        <div class="partner-grid">
          <el-link href="" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner10Url" alt="Avsonics" class="partner-logo" />
          </el-link>
          <el-link href="" target="_blank" class="partner-item">
            <el-image fit="contain" :src="partner11Url" alt="NACCCA" class="partner-logo" />
          </el-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ChatDotSquare, Lightning, CircleCheckFilled } from '@element-plus/icons-vue'
import { Store } from '@/utils/store'
import { Lang } from '@/utils/language'
export default {
  name: 'HomeView',
  components: { ChatDotSquare, Lightning, CircleCheckFilled },
  data() {
    return {
      serviceUrl: require('@/assets/home/service.png'),
      partner1Url: require('@/assets/home/ameleco-logo.jpg'),
      partner2Url: require('@/assets/home/ebhorsman-logo.png'),
      partner3Url: require('@/assets/home/sselectrical-logo.png'),
      partner4Url: require('@/assets/home/homapp-logo.png'),
      partner10Url: require('@/assets/home/avsonics-logo.png'),
      partner11Url: require('@/assets/home/naccca-logo.png'),
    }
  },
  computed: {
    title() {
      return Store.lang === 'en' ? Lang.Home.en[0] : Lang.Home.cn[0]
    },
    title1() {
      return Store.lang === 'en' ? Lang.Home.en[1] : Lang.Home.cn[1]
    },
    title2() {
      return Store.lang === 'en' ? Lang.Home.en[2] : Lang.Home.cn[2]
    },
    title3() {
      return Store.lang === 'en' ? Lang.Home.en[3] : Lang.Home.cn[3]
    },
    serviceCards() {
      const [heading, ...features] = this.title2
      const icons = [ChatDotSquare, Lightning, CircleCheckFilled]
      return features.map((label, i) => ({ label, icon: icons[i] || Shield }))
    },
  },
  methods: {
    handleProduct() {
      this.$router.push({ name: 'Production', hash: '#production-section-1' })
    },
    handleQuote() {
      this.$router.push({ name: 'Production', hash: '#production-section-2' })
    },
    handleAbout() {
      this.$router.push({ name: 'About' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

// Keyframes
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}
@keyframes pulse {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.05); }
}
@keyframes ringRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes cardIn {
  from { opacity: 0; transform: translateY(40px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.home { width: 100%; }

// ====================
// Hero
// ====================
.home-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 1474 / 829;
  background-image: url('../assets/home/banner.png');
  background-size: cover;
  background-position: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: $gradient-hero;
  z-index: 1;
}
.hero-decoration {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}
.hero-dot {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
}
.hero-dot-1 { width: 200px; height: 200px; top: -40px; right: 15%; animation: float 6s ease-in-out infinite; }
.hero-dot-2 { width: 120px; height: 120px; bottom: 10%; right: 8%; animation: float 8s ease-in-out infinite 1s; }
.hero-dot-3 { width: 80px; height: 80px; top: 30%; left: 5%; background: rgba($brand-primary-light, 0.2); animation: pulse 4s ease-in-out infinite; }
.hero-ring {
  position: absolute;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50%;
  animation: ringRotate 20s linear infinite;
}
.hero-ring-1 { width: 300px; height: 300px; top: -80px; right: 25%; }
.hero-ring-2 { width: 180px; height: 180px; bottom: 5%; left: 30%; animation-duration: 15s; animation-direction: reverse; }

.hero-content {
  position: relative;
  z-index: 2;
  max-width: $max-content;
  margin: 0 auto;
  padding: 0 5%;
  width: 100%;
  box-sizing: border-box;
}
.hero-badge {
  display: inline-block;
  font-size: 0.85em;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.25);
  padding: 6px 18px;
  border-radius: 20px;
  margin-bottom: 20px;
  animation: fadeUp 0.6s ease both;
}
.hero-title {
  font-size: 3.2em;
  line-height: 1.2;
  color: #fff;
  margin: 0 0 16px;
  animation: fadeUp 0.6s ease 0.15s both;
}
.hero-text {
  font-size: 1.3em;
  color: rgba(255,255,255,0.85);
  max-width: 600px;
  line-height: 1.6;
  margin: 0 0 32px;
  animation: fadeUp 0.6s ease 0.3s both;
}
.hero-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  animation: fadeUp 0.6s ease 0.45s both;
}
.hero-btn { padding: 12px 32px; font-size: 1em; border-radius: 6px; transition: $transition-normal; }
.hero-btn:hover { transform: translateY(-2px); box-shadow: $shadow-md; }
.hero-btn-outline {
  border-color: rgba(255,255,255,0.6);
  color: #fff;
  background: transparent;
}
.hero-btn-outline:hover {
  border-color: #fff;
  background: rgba(255,255,255,0.1);
}

// ====================
// Mission
// ====================
.home-mission {
  position: relative;
  width: 100%;
  padding: 80px 5%;
  text-align: center;
  overflow: hidden;
  box-sizing: border-box;
}
.mission-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.mission-text {
  font-size: 1.15em;
  line-height: 1.8;
  color: $neutral-600;
  margin: 0 auto 16px;
  max-width: 680px;
}
.mission-btn {
  margin-top: 16px;
  padding: 12px 40px;
  font-size: 1em;
  transition: $transition-normal;
}
.mission-btn:hover { transform: translateY(-2px); box-shadow: $shadow-lg; }
.mission-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}
.mission-shape {
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba($brand-primary-lighter, 0.5) 0%, transparent 70%);
  top: -200px;
  right: -100px;
  animation: float 10s ease-in-out infinite;
}

// ====================
// Service
// ====================
.home-service {
  width: 100%;
  background: $neutral-100;
  padding: 80px 5%;
  box-sizing: border-box;
}
.service-inner {
  max-width: $max-content;
  margin: 0 auto;
}
.service-header {
  text-align: center;
  margin-bottom: 40px;
}
.service-cards {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 48px;
}
.service-card {
  flex: 1;
  min-width: 200px;
  max-width: 280px;
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  box-shadow: $shadow-sm;
  transition: $transition-normal;
  animation: cardIn 0.5s ease calc(var(--delay) + 0.1s) both;
  cursor: default;
}
.service-card:hover {
  transform: translateY(-6px);
  box-shadow: $shadow-lg;
}
.service-card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: $brand-primary-lighter;
  color: $brand-primary;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: $transition-normal;
}
.service-card:hover .service-card-icon {
  background: $brand-primary;
  color: #fff;
}
.service-card-title {
  font-size: 1.1em;
  color: $neutral-700;
  margin: 0;
}
.service-image-wrapper {
  text-align: center;
}
.service-image {
  max-width: 100%;
  border-radius: 12px;
  box-shadow: $shadow-md;
}

// ====================
// Partners
// ====================
.home-partner {
  width: 100%;
  padding: 80px 5%;
  box-sizing: border-box;
}
.partner-inner {
  max-width: $max-content;
  margin: 0 auto;
}
.partner-header {
  text-align: center;
  margin-bottom: 48px;
}
.partner-grid {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}
.partner-item {
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: $transition-normal;
}
.partner-logo {
  height: 60px;
  width: auto;
  max-width: 180px;
  filter: grayscale(100%) brightness(1.05);
  transition: $transition-normal;
  border-radius: 8px;
}
.partner-item:hover .partner-logo {
  filter: grayscale(0%) brightness(1);
  transform: scale(1.05);
}

// Common
.section-accent {
  display: block;
  width: 40px;
  height: 4px;
  background: $brand-primary;
  border-radius: 2px;
  margin: 0 auto 20px;
}

// Responsive
@media screen and (min-width: 1201px) {
  .hero-title { font-size: 3.2em; }
  .hero-content { padding: 0 10%; }
  .home-mission { min-height: auto; padding: 100px 10%; }
  .home-service { padding: 100px 10%; }
  .home-partner { padding: 100px 10%; }
}
@media screen and (max-width: 1200px) {
  .hero-title { font-size: 1.8em; }
  .hero-text { font-size: 1em; }
  .hero-content { padding: 0 5%; }
  .home-mission { padding: 50px 5%; }
  .home-service { padding: 50px 5%; }
  .home-partner { padding: 50px 5%; }
  .partner-logo { height: 45px; max-width: 140px; }
  .hero-badge { font-size: 0.75em; }
}
@media screen and (max-width: 768px) {
  .hero-title { font-size: 1.4em; }
  .hero-text { font-size: 0.9em; }
  .service-card { min-width: 140px; max-width: 100%; flex: 1 1 100%; }
  .partner-grid { gap: 20px; }
  .hero-dot-1, .hero-dot-2, .hero-dot-3 { display: none; }
  .hero-ring-1, .hero-ring-2 { display: none; }
}
</style>
